import { Prototype } from '@core';
import { useFetchDashboardAllocationReportInfinity } from '@hooks';
import InfiniteScrollWrapper from '@pages/Dashboard/components/InfiniteScrollWrapper';
import { onShowContainer } from '@pages/TransportJob/helpers';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import trans from 'translation';
import { KButton, KColors, KContainer, KInput, KLabel } from 'uikit';

const NOW = Prototype.date.now();

const NotificationsPOD = () => {
  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>();
  const [keyword, setKeyword] = useState('');

  const onKeywordChange = useCallback((e: any) => {
    setKeyword(e?.target?.value ?? '');
  }, []);

  const {
    dataFlatten: data,
    isLoading,
    hasNextPage,
    onEndReached
  } = useFetchDashboardAllocationReportInfinity(
    Prototype.date.formatDB(NOW),
    keyword
  );

  const renderRow = useCallback((item: any) => {
    return (
      <KContainer.View
        row
        background={'#F8F9FA'}
        br={'2x'}
        padding={'1rem'}
        marginB="0.5rem"
        key={`r-${item.id}`}
      >
        <KContainer.View dp="flex" width={'100%'}>
          <KContainer.View
            dp="flex"
            row
            alignItems="center"
            justifyContent="space-between"
          >
            <KLabel.Text
              typo="TextLgBold"
              color={KColors.primary.normal}
              isLink
              onPress={() =>
                onShowContainer(item?.container, {
                  transportJobId: item?.container?.transportJobId,
                  selectedContainer: item?.container
                })
              }
            >
              {item.name}
            </KLabel.Text>
            <KButton.Icon
              icon="SaveAlt"
              onPress={() => window.open(item?.resource?.url, '_blank')}
            />
          </KContainer.View>
          <KLabel.Text typo="TextMdBold" color={'#344767'}>
            {item.driverReport?.displayName}
          </KLabel.Text>
          <KLabel.Text color={'#7B809A'}>
            {Prototype.date.formatDT(item.createdAt)}
          </KLabel.Text>
        </KContainer.View>
      </KContainer.View>
    );
  }, []);

  useEffect(() => {
    if (location.state?.scrollToBottom) {
      window.history.replaceState({}, document.title);
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.state]);

  return (
    <KContainer.View
      marginT={0}
      ref={scrollRef as any}
      dp="flex"
      alignItems="stretch"
      flexG={1}
    >
      <KContainer.View dp="flex" flex position="relative">
        {/* <KContainer.View row alignItems>
          <KContainer.View dp="flex" flex>
            <KLabel.Text typo="TextXNmMedium">{trans('report')}</KLabel.Text>
          </KContainer.View>

          <KContainer.View dp="flex" flex={1}>
            <KLabel.Text typo="TextXNmMedium">
              {trans('created_by')}
            </KLabel.Text>
          </KContainer.View>

          <KContainer.View dp="flex" flex={2}>
            <KLabel.Text typo="TextXNmMedium">{trans('type')}</KLabel.Text>
          </KContainer.View>

          <KContainer.View width={30} />
        </KContainer.View> */}
        <KContainer.View marginB="0.5rem">
          <KInput.Search
            width={230}
            fullWidth={false}
            value={keyword}
            placeholder={trans('search_placeholder')}
            name="allocationReportSearch"
            onChange={onKeywordChange}
            disabled={isLoading && data.length <= 0}
          />
          {/* <TextFieldSearch
            columns={generateOptions(ParentSource, {
              key: 'name',
              uppercase: false
            })}
            handleSearchValue={setSearchValue}
            handleChangeSearchField={setSearchField}
            mapColumns={mapMUITableColumnsToFilterColumns}
          /> */}
        </KContainer.View>

        <InfiniteScrollWrapper
          name="notificationPODDiv"
          data={data}
          isLoading={isLoading}
          hasNextPage={hasNextPage ?? false}
          onEndReached={onEndReached}
          renderRow={renderRow}
        />
      </KContainer.View>
    </KContainer.View>
  );
};

export default memo(NotificationsPOD);
